import React from 'react';
import { useNewRegistrationPanelFlag } from 'shared/featureFlags';
import { RegistrationMethodContainer } from './RegistrationMethod';
import { RegistrationMethodV2 } from './RegistrationMethodV2';

const ABTestRegistration: React.FC = () => {
	const newRegistrationPanelFlag = useNewRegistrationPanelFlag();
	const localNewRegistrationPanelFlag = newRegistrationPanelFlag && newRegistrationPanelFlag.value;

	return localNewRegistrationPanelFlag ? <RegistrationMethodV2 /> : <RegistrationMethodContainer />;
};

export default ABTestRegistration;
